import { Button, Image, Modal, Spin, Table } from 'antd';
import React, { useState } from 'react';
import useSWR from 'swr';

import { fetchRouteDetailData, getDetailTableColumns } from './helpers';
import styles from './index.module.scss';

type DetailModalProps = {
  open: boolean;
  closeModal: () => void;
  routeId: string | undefined;
};

const attachmentColumnRenderer = (value: string) => {
  if (!value) {
    return null;
  }
  return <Image src={value} alt="附件" className={styles.attachment} />;
};

const pageSize = 10;

const DetailModal = ({ open, closeModal, routeId }: DetailModalProps) => {
  const [page, setPage] = useState(1);

  const { data: routeDetail, isLoading } = useSWR(
    routeId
      ? {
          url: `/ezcon/api/machineInspectionPlans/${routeId}/machineInspectionRecords`,
          page,
          pageSize,
        }
      : null,
    fetchRouteDetailData
  );

  const columns = getDetailTableColumns(attachmentColumnRenderer);

  return (
    <Modal
      title="巡檢紀錄"
      width={900}
      open={open}
      centered
      onCancel={closeModal}
      footer={<Button onClick={closeModal}>關閉</Button>}
    >
      <Table
        rowKey="id"
        loading={{
          spinning: isLoading,
          indicator: <Spin size="large" />,
        }}
        columns={columns}
        dataSource={routeDetail ? routeDetail.data : []}
        scroll={{ x: 'max-content' }}
        pagination={{
          current: page,
          pageSize,
          total: routeDetail ? routeDetail.totalPages * pageSize : 0,
          onChange: setPage,
        }}
      />
    </Modal>
  );
};

export default DetailModal;
